<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t("auth.Profile") }}</h6>
          <p class="font13 gray-col">{{ $t("auth.changePassMain") }}</p>
        </div>
      </div>
      <div class="card-details-def pad-big">
        <div class="gray-col mb-4 font14">
          {{ $t("auth.sendOtpphase") }}
        </div>
        <div class="col-md-5 col-12">
          <v-form @submit.prevent="sendCode">
            <div class="code-container edit mb-4">
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                separator=" "
                :num-inputs="6"
                v-model="code"
                :should-auto-focus="true"
                name="otpInput"
                :is-input-num="true"
              />
            </div>
            <button
              type="submit"
              :disabled="disabled"
              class="main-btn up xl w-100 mt-3"
            >
              <div v-if="!disabled">{{ $t("auth.confirm") }}</div>
              <div class="loading" role="status" v-if="disabled">
                {{ $t("auth.confirming") }}
                <div class="spinner-small-white" v-if="disabled"></div>
              </div>
            </button>
            <div class="flex-bet-main mt-3 font14">
              <div class="have-you gray-col">
                {{ $t("auth.didnotrecieve") }}
                <button class="resend-btn" :disabled="disabledBtn || loadingResend" @click="resendCode" type="button">
                  <div>{{ $t("auth.newCode") }}</div>
                </button>
              </div>
               <div class="text-center fs15 c-sec" v-if="counterNum > 0">{{ counterText }}</div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import { ref, onMounted } from "vue";
// import ChangePassword from "./changePassword.vue";
import VOtpInput from "vue3-otp-input";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();

// reactive state

const disabled = ref(false);
const otpInput = ref(null);


// counter
const counterNum = ref(60);
const counterText = ref('');
const disabledBtn = ref(false);
const loadingResend = ref(false);

// functions

function sendCode() {
  disabled.value = true;
  const fd = new FormData();
  let otpString = JSON.stringify(otpInput.value.otp.join(""));
  let otpsNumber = JSON.parse(otpString);
  fd.append("code", otpsNumber);
  fd.append("phone", localStorage.getItem("phone"));
  fd.append("country_code", Number(localStorage.getItem("country_code")));

  axios
    .post("/manager/change-phone-check-code", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        router.push("/editProfile");
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function resendCode() {
    loadingResend.value = true
  const fd = new FormData();
  fd.append("phone", localStorage.getItem("phone"));
  fd.append("country_code", localStorage.getItem("country_code"));
  fd.append("password", localStorage.getItem("password"));

  axios
    .post("/manager/change-phone-resend-code", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
           counterNum.value = 60;
      codeCounter();
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
    });

    loadingResend.value = false
}


let counter;
function codeCounter() {
    disabledBtn.value = true;

    counter = setInterval(function () {
        counterNum.value--;
        if (counterNum.value < 60) {
            counterText.value = `${counterNum.value} : 00`;
        }

        if (counterNum.value > 60) {
            counterText.value = `00 : ${counterNum.value}`;
        }

        if (counterNum.value < 10) {
            counterText.value = `0${counterNum.value} : 00`;
        }

        if (counterNum.value == 0) {
            clearInterval(counter);
            disabledBtn.value = false;
        }
    }, 1000);
}

// lifecycle hooks
onMounted(() => {
  codeCounter();
});
</script>
